"use client";

import * as React from "react";
import { DialogComponent } from "@/components/DialogComponent";
import { queryClient } from "@/lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { NextIntlClientProvider } from "next-intl";

export default function ClientLayout({
  children,
  params: { locale },
  messages,
  timeZone,
  now,
}: Readonly<{
  children: React.ReactNode;
  params: { locale: string };
  messages: Record<string, unknown>;
  timeZone: string;
  now: Date;
}>) {
  // Messages are now passed from the parent component

  return (
    <NextIntlClientProvider
      locale={locale}
      messages={messages}
      timeZone={timeZone}
      now={now}
    >
      <QueryClientProvider client={queryClient}>
        {children}
        <DialogComponent />
      </QueryClientProvider>
    </NextIntlClientProvider>
  );
}
